import { useEffect, useState } from 'react';
import { useBulkPrescriptionClassifications } from './useBulkPrescriptionClassifications';
import type { BulkDemandClassifications } from './prescriptionDemandMode';

type DemandMapSelection = { classificationsEnabled: boolean; sourceLayer: string | null };

export const useBulkDemandClassifications = (
  isOnBulkOverview: boolean,
  leftMap: DemandMapSelection,
  centerMap: DemandMapSelection
): Record<string, BulkDemandClassifications> => {
  const [classificationsByLayer, setClassificationsByLayer] = useState<
    Record<string, BulkDemandClassifications>
  >({});
  const { fetchDemandForBulkPrescription } = useBulkPrescriptionClassifications();

  useEffect(() => {
    if (!isOnBulkOverview) return;

    let active = true;
    const layers = [
      ...new Set(
        [leftMap, centerMap]
          .filter(
            (map): map is DemandMapSelection & { sourceLayer: string } =>
              map.classificationsEnabled && Boolean(map.sourceLayer)
          )
          .map((map) => map.sourceLayer)
      ),
    ];

    layers.forEach((layer) => {
      if (classificationsByLayer[layer]) return;
      fetchDemandForBulkPrescription(layer)
        .then((classifications: BulkDemandClassifications) => {
          if (active) {
            setClassificationsByLayer((previous) => ({ ...previous, [layer]: classifications }));
          }
        })
        .catch(() => {
          if (active) setClassificationsByLayer((previous) => ({ ...previous, [layer]: {} }));
        });
    });

    return () => {
      active = false;
    };
  }, [
    isOnBulkOverview,
    leftMap.classificationsEnabled,
    centerMap.classificationsEnabled,
    leftMap.sourceLayer,
    centerMap.sourceLayer,
  ]);

  return classificationsByLayer;
};
